import {
  DownloadOutlined,
  EyeOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Button, Flex, Form, Input, Table, Tooltip, Typography } from "antd";
import { Card, Col, Collapse, List, Row } from "antd";
import React, { FC, useEffect, useState } from "react";

const { Panel } = Collapse;
const { Text } = Typography;

type EnhancementProcedureListForCghsProps = {
  enhancementsList: any;
  handleDownloadDocument: any;
  isDownloadingDocument?: boolean;
  downloadingDocumentUrl?: string;
  handleOpen: any;
  handleSetDocumentUrl: any;
  setDocumentName: any;
  handleDeficiencyModal: any;
};

const EnhancementProcedureListForCghs: FC<
  EnhancementProcedureListForCghsProps
> = (props) => {
  // const filteredEnhancement = props?.enhancementsList?.filter((enhancementItem: any) => enhancementItem?.enhancementProceduresResponseList);

  const calculateTotal = (data: any[]) => {
    return data?.reduce((sum: number, procedure: any) => {
      const amount = procedure?.unspecifiedProcedureAmount
        ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
          parseFloat(procedure?.numberOfDays)
        : parseFloat(procedure?.procedureAmount || "0") *
          parseFloat(procedure?.numberOfDays);
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      dataSource={props?.enhancementsList}
      renderItem={(item: any, index) => (
        <List.Item>
          <Card
            className="enhancement-card"
            title={`Enhancement-${props?.enhancementsList?.length - index}`}
            style={{ cursor: "pointer", backgroundColor: "white" }}
          >
            <Collapse defaultActiveKey={["1"]}>
              <Panel header="Procedure" key="1">
                <Form>
                  {item?.enhancementProceduresResponseList &&
                  item?.enhancementProceduresResponseList?.length > 0 ? (
                    item?.enhancementProceduresResponseList?.map(
                      (procedure: any) => (
                        <Row
                          key={procedure?.id}
                          gutter={[16, 16]}
                          align="top"
                          style={{
                            border: "1px solid #008B8B",
                            padding: "10px 20px",
                            borderRadius: "16px",
                            marginBottom: "0.8rem",
                            background: "white",
                            boxShadow: "0px 2px 8px 0px #00000040",
                          }}
                        >
                          <Col span={8}>
                            <Form.Item
                              label="PROCEDURE REFERRAL"
                              name={"procedureReferral"}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {/* <Select
                              showSearch
                              defaultValue={`Select a Procedure Referral`}
                              options={props?.formattedProcedureReferral}
                              disabled={true}
                              style={{color: "black"}}
                            /> */}
                              <Input
                                defaultValue={procedure?.procedureReferral}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="Procedure"
                              name={"procedureName"}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={procedure?.procedureName}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={7}>
                            <Form.Item
                              label="Procedure Code"
                              name={"externalProcedureCode"}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                style={{ borderRadius: "5px", color: "black" }}
                                placeholder="Enter Procedure Code"
                                disabled={true}
                                defaultValue={procedure?.externalProcedureCode}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="QUANTITY/NO OF DAYS"
                              name={"numberOfDays"}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={procedure?.numberOfDays}
                                disabled={true}
                                placeholder="Enter QUANTITY/NO OF DAYS"
                                style={{ borderRadius: "5px", color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="ACCREDITATION STATUS"
                              name={"accreditationStatus"}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                disabled={true}
                                defaultValue={procedure?.accreditationStatus}
                                style={{ borderRadius: "5px", color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={7}>
                            <Form.Item
                              label="TREATING DOCTOR"
                              name={"treatingDoctor"}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                disabled={true}
                                defaultValue={procedure?.treatingDoctor}
                                style={{ borderRadius: "5px", color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="TREATMENT START DATE"
                              name={"treatmentStartDate"}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <Input
                                disabled={true}
                                defaultValue={procedure?.treatmentStartDate}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          {!procedure?.procedureName
                            ?.toLowerCase()
                            ?.includes("unspecified") ? (
                            <Col span={8}>
                              <Form.Item
                                label="AMOUNT"
                                name={"procedureAmount"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={procedure?.procedureAmount}
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Amount"
                                  disabled={true}
                                />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )}

                          {procedure?.procedureName
                            ?.toLowerCase()
                            ?.includes("unspecified") ? (
                            <Col span={8}>
                              <Form.Item
                                label="PROCEDURE NAME"
                                name={"unspecifiedProcedureName"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={
                                    procedure?.unspecifiedProcedureName
                                  }
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Procedure Name"
                                  disabled={true}
                                />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )}

                          {procedure?.procedureName
                            ?.toLowerCase()
                            ?.includes("unspecified") ? (
                            <Col span={7}>
                              <Form.Item
                                label="PROCEDURE AMOUNT"
                                name={"unspecifiedProcedureAmount"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={
                                    procedure?.unspecifiedProcedureAmount
                                  }
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Procedure Amount"
                                  disabled={true}
                                />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )}

                          {procedure?.strats?.toLowerCase()?.includes("y") ? (
                            <Col span={7}>
                              <Form.Item
                                label="STRATS NAME"
                                name={"stratsName"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={procedure?.stratsName}
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Strats Name"
                                  disabled={true}
                                />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )}

                          {procedure?.strats?.toLowerCase()?.includes("y") ? (
                            <Col span={8}>
                              <Form.Item
                                label="STRATS OPTIONS"
                                name={"stratOptionValue"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={procedure?.stratOptionValue}
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Strats Option"
                                  disabled={true}
                                />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )}

                          <div style={{ width: "100%" }}>
                            <h4
                              style={{ display: "flex", justifyContent: "end" }}
                            >
                              Amount: ₹{" "}
                              {!procedure?.procedureName
                                ?.toLowerCase()
                                ?.includes("unspecified")
                                ? parseFloat(procedure?.numberOfDays) *
                                  parseFloat(procedure?.procedureAmount)
                                : parseFloat(procedure?.numberOfDays) *
                                  parseFloat(
                                    procedure?.unspecifiedProcedureAmount
                                  )}
                              /-
                            </h4>
                          </div>
                        </Row>
                      )
                    )
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      NO PROCEDURE
                    </div>
                  )}

                  {
                    item?.enhancementProceduresResponseList &&
                    item?.enhancementProceduresResponseList?.length > 0 ? <div style={{ width: "100%", marginBottom: "0.8rem" }}>
                    <h4 style={{ display: "flex", justifyContent: "end" }}>
                      Total Amount: ₹ {calculateTotal(item?.enhancementProceduresResponseList) ?? 0}/-
                    </h4>
                  </div> : <></>
                  }
                </Form>
              </Panel>
              <Panel header="Documents" key="2">
                {item?.enhancementDocuments &&
                item?.enhancementDocuments?.length > 0 ? (
                  <Table
                    showHeader={false}
                    dataSource={item?.enhancementDocuments}
                    columns={[
                      {
                        title: "Document Type",
                        dataIndex: "documentLabelType",
                        key: "documentType",
                        width: "30%",
                        render: (type: string) => (
                          <Flex justify="center">
                            <Text style={{ color: "#7c8181" }}>{type}</Text>
                          </Flex>
                        ),
                      },
                      {
                        title: "Document Name",
                        dataIndex: "documentName",
                        key: "documentName",
                        width: "30%",

                        render: (name: string) => (
                          <Flex justify="center">
                            <Tooltip title={name}>
                              <Text strong style={{ color: "#7c8181" }}>
                                {name?.length > 20
                                  ? name?.substring(0, 20) + "..."
                                  : name}
                              </Text>
                            </Tooltip>
                          </Flex>
                        ),
                        // width: 520,
                      },
                      {
                        title: "Actions",
                        key: "actions",
                        width: "40%",
                        render: (_, document, i) => (
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              justifyContent: "center",
                            }}
                          >
                            {props?.isDownloadingDocument &&
                            props?.downloadingDocumentUrl ===
                              document?.documentUrl ? (
                              <LoadingOutlined
                                style={{ color: "#273881", fontSize: "18px" }}
                              />
                            ) : (
                              <Tooltip title="Download File">
                                <DownloadOutlined
                                  style={{
                                    color: "#273881",
                                    fontSize: "18px",
                                  }}
                                  onClick={() =>
                                    props?.handleDownloadDocument(
                                      document?.documentName,
                                      document?.documentUrl
                                    )
                                  }
                                />
                              </Tooltip>
                            )}
                            <Tooltip title="View File">
                              <EyeOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() => {
                                  props?.handleOpen();
                                  props?.handleSetDocumentUrl(
                                    document?.documentUrl
                                  );
                                }}
                              />
                            </Tooltip>
                            {document?.deficiencyCheckStatus ? (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    props?.setDocumentName(
                                      document?.documentName
                                    );
                                  }
                                  if (document?.documentType) {
                                    props?.handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                                style={{ backgroundColor: "rgb(0, 109, 119)" }}
                              >
                                DEFICIENCY PASSED
                              </Button>
                            ) : document?.deficiencyCheckStatus === false ? (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    props?.setDocumentName(
                                      document?.documentName
                                    );
                                  }
                                  if (document?.documentType) {
                                    props?.handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                                danger
                              >
                                DEFICIENCY FAILED
                              </Button>
                            ) : (
                              <></>
                            )}
                          </div>
                        ),
                      },
                    ]}
                    rowKey={(record) =>
                      record.documentName || `document-${record.documentUrl}`
                    }
                    pagination={false}
                    className="showUploadDoc"
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    NO DOCUMENT UPLOADED
                  </div>
                )}
              </Panel>
            </Collapse>
          </Card>
        </List.Item>
      )}
    />
  );
};

export default EnhancementProcedureListForCghs;
